// const keys = { 37: 1, 38: 1, 39: 1, 40: 1 }

// const preventDefault = (e) => {
//   const event = e || window.event
//   if (event.preventDefault) e.preventDefault()
//   event.returnValue = false
// }

// const preventDefaultForScrollKeys = (e) => {
//   if (keys[e.keyCode]) {
//     preventDefault(e)
//     return false
//   }
// }

export const disableScroll = () => {
  // if (window.addEventListener) {
  //   // older FF
  //   window.addEventListener('DOMMouseScroll', preventDefault, false)
  // }
  document.body.style.overflow = 'hidden'
  // window.onwheel = preventDefault // ! modern standard
  // // @ts-ignore
  // window.onmousewheel = document.onmousewheel = preventDefault // ! older browsers, IE
  // window.ontouchmove = preventDefault // mobile
  // document.onkeydown = preventDefaultForScrollKeys
}

export const enableScroll = () => {
  // if (window.removeEventListener) {
  //   window.removeEventListener('DOMMouseScroll', preventDefault, false)
  // }
  document.body.style.overflow = 'initial'
  // @ts-ignore
  // window.onmousewheel = document.onmousewheel = null
  // window.onwheel = null
  // window.ontouchmove = null
  // document.onkeydown = null
}
